module.exports = __webpack_public_path__ + "img/noData.57106394.svg";